import styled from 'styled-components';

import { VerifiedList } from '../../../../../components/PageWrappers/AdDetails/components/VerifiedList/VerifiedList';
import { TextArea } from '../../../../../components/Toolkit/Inputs/TextArea';

const SVerifiedList = styled(VerifiedList)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

const STextArea = styled(TextArea)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export { SVerifiedList, STextArea };
